import { render, staticRenderFns } from "./numerSplit.vue?vue&type=template&id=067d7427&scoped=true"
import script from "./numerSplit.vue?vue&type=script&lang=js"
export * from "./numerSplit.vue?vue&type=script&lang=js"
import style0 from "./numerSplit.vue?vue&type=style&index=0&id=067d7427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d7427",
  null
  
)

export default component.exports